import axios, { AxiosInstance } from 'axios'
import Cookies from 'js-cookie'
import { stringify } from 'qs'

const SESSION_KEY = 'KANSEI-APP-SESSION'

export function _axios(): AxiosInstance {
  const api: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
    paramsSerializer: (params) => {
      return stringify(params, { arrayFormat: 'repeat' })
    },
  })

  api.interceptors.request.use((request) => {
    const sessionKey = Cookies.get(SESSION_KEY)
    if (sessionKey) {
      request.headers.Authorization = sessionKey
    }
    return request
  })

  api.interceptors.response.use(
    (response) => {
      // 最終アクセス日時を更新(認証済みかつlast-accessed-atエンドポイント以外)
      const sessionKey = Cookies.get(SESSION_KEY)
      if (sessionKey && !response.config.url?.includes('/last-accessed-at')) {
        // awaitでまたずに非同期で更新(元のレスポンスをブロックしない)
        axios
          .put(
            `${process.env.REACT_APP_API_HOST}/last-accessed-at`,
            {},
            {
              headers: {
                Authorization: sessionKey,
              },
            },
          )
          .catch((error) => {
            console.warn('Failed to update last accessed time:', error)
          })
      }
      return response
    },
    (error) => {
      const response = error.response
      throw response
    },
  )
  return api
}

export function AddAuthSession(token: string) {
  Cookies.set(SESSION_KEY, token)
}

export function GetAuthSession(): string | undefined {
  const token = Cookies.get(SESSION_KEY)
  return token
}
